import BaseApi from "Services/http/BaseApi";
import {headers} from "Services/http/ApiSettings";

class Customer extends BaseApi {
    constructor() {
        super({suffix: ""});
    }

    getAllMoshtariTblData(params) {
        return this.httpService.get("Definition/all-customer", {headers, params})
    }

    getAllMoshtariList(params) {
        return this.httpService.get("Definition/all-customer", {headers, params})
    }

    getGrouhMoshtari(params) {
        return this.httpService.get("Definition/combo-group-customer", {headers, params})
    }

    InsertMoshtariData(data) {
        return this.httpService.post("Definition/insert-customer", data, {headers})
    }

    deleteMoshtari(data) {
        return this.httpService.delete("Definition/delete-customer", {headers, data})
    }

    getRelationMoshtari(params) {
        return this.httpService.get("Definition/relation-customer", {headers, params})
    }

    UpdateMoshtariData(data) {
        return this.httpService.put("Definition/update-customer", data, {headers})
    }

    getAllGorouhMoshtari(params) {
        return this.httpService.get("Definition/all-group-customer", {headers, params})
    }

    InsertGorouhMoshtariData(data) {
        return this.httpService.post("Definition/insert-group-customer", data, {headers})
    }

    UpdateGorouhMoshtariData(data) {
        return this.httpService.put("Definition/update-group-customer", data, {headers})
    }

    deleteGorouhMoshtari(data) {
        return this.httpService.delete("Definition/delete-group-customer", {headers, data})
    }

    getRelationGtoupMoshtari(params) {
        return this.httpService.get("Definition/relation-group-customer", {headers, params})
    }

    getComboMoshtari(params) {
        return this.httpService.get("Definition/combo-customer", {headers, params})
    }
}

const CustomerService = new Customer();
export default CustomerService;